import { PropsWithChildren } from "react";

export type ExpanderButtonProps = {
    isOpen: boolean,
    targetId: string,
    toggled: () => void,
}

export function ExpanderLogicButton(props: PropsWithChildren<ExpanderButtonProps>) {
    return (
        <>
            <button
                aria-controls={`bdyCollapse_${props.targetId}`}
                data-bs-target={`#bdyCollapse_${props.targetId}`}
                aria-expanded={`${props.isOpen ? "true" : "false"}`}
                onClick={e => { props.toggled() }}
                data-bs-toggle="collapse"
                className={`card-mini-button align-content-center fa-solid ${(props.isOpen ? "fa-chevron-up" : "fa-chevron-down")}`}></button>
        </>
    );
}